import { TSelectContentBlock, TSelectPlanBlock } from '@/config/types'
import { SelectLTPBlockType } from '@/enums/ltp'
import { SelectPlanBlockType, selectPlanBlocksWithPayment } from '@/enums/payments'

export function checkSelectPlanBlocks(blocks: TSelectPlanBlock[]): void {
  const stats = blocks.reduce(
    (accumulator, block) => {
      if (typeof block === 'function') {
        return accumulator
      }
      if (block.blockType === SelectPlanBlockType.paymentModalWindow) {
        accumulator.paymentModalCount++
      } else if (block.anchor) {
        accumulator.anchorCount++
      }

      if (selectPlanBlocksWithPayment.indexOf(block.blockType) !== -1) {
        accumulator.blocksWithPayment++
      }

      return accumulator
    },
    {
      anchorCount: 0,
      paymentModalCount: 0,
      blocksWithPayment: 0,
    }
  )

  if (stats.anchorCount !== 1) {
    console.error('Anchors count != 1 ')
  }
  if (stats.paymentModalCount > 1) {
    console.error('More than 1 payment modal windows found')
  }
  if (stats.blocksWithPayment > 0 && stats.paymentModalCount === 0) {
    console.error('Payment Modal is not defined')
  }
}
export function checkSelectContentBlocks(blocks: TSelectContentBlock[]): void {
  const stats = blocks.reduce(
    (accumulator, block) => {
      if (typeof block === 'function') {
        return accumulator
      }
      if (block.blockType === SelectLTPBlockType.paymentModalWindow) {
        accumulator.paymentModalCount++
      } else if ('anchor' in block && block.anchor) {
        accumulator.anchorCount++
      }

      return accumulator
    },
    {
      anchorCount: 0,
      paymentModalCount: 0,
    }
  )

  if (stats.anchorCount > 1) {
    console.error('Anchors count > 1 ')
  }
  if (stats.paymentModalCount > 1) {
    console.error('More than 1 payment modal windows found')
  }
}
